import { DataGrid, DataGridProps } from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Box } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import BaseLayout from "layouts/pages/account/components/BaseLayout";

const LOJA_ACCENT = "#F96030";

export function LojaPageContainer({
  title,
  subtitle,
  actions,
  children,
}: {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <BaseLayout>
      <MDBox mt={4}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card
              sx={{
                border: "1px solid",
                borderColor: "grey.200",
                borderRadius: 2,
                boxShadow: "none",
                overflow: "hidden",
              }}
            >
              <MDBox
                pt={3}
                px={3}
                pb={actions ? 2 : 1}
                display="flex"
                justifyContent="space-between"
                alignItems="flex-start"
                flexWrap="wrap"
                gap={2}
                sx={{
                  borderBottom: "1px solid",
                  borderColor: "grey.200",
                  bgcolor: "grey.50",
                }}
              >
                <Box
                  sx={{
                    borderLeft: `4px solid ${LOJA_ACCENT}`,
                    pl: 2,
                    minWidth: 0,
                  }}
                >
                  <MDTypography variant="h5" fontWeight="bold">
                    {title}
                  </MDTypography>
                  {subtitle ? (
                    <MDTypography variant="body2" color="text.secondary" mt={0.5}>
                      {subtitle}
                    </MDTypography>
                  ) : null}
                </Box>
                {actions ? <MDBox>{actions}</MDBox> : null}
              </MDBox>
              <MDBox px={3} py={3}>
                {children}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </BaseLayout>
  );
}

export function LojaDataGrid(props: DataGridProps) {
  return (
    <DataGrid
      autoHeight
      pageSizeOptions={[10, 25, 50, 100]}
      disableRowSelectionOnClick
      {...props}
      sx={{
        border: "1px solid",
        borderColor: "grey.200",
        borderRadius: 2,
        "& .MuiDataGrid-columnHeaders": {
          bgcolor: "grey.100",
          fontWeight: 700,
        },
        "& .MuiDataGrid-row:hover": {
          bgcolor: "rgba(249, 96, 48, 0.04)",
        },
        ...props.sx,
      }}
    />
  );
}
